import React, { useState, useEffect } from "react";
import { EnergyDataContext } from "./context";

import { getEnergyData } from "../services/services";

const EnergyProvider = ({ children }) => {
  const [energyData, setEnergyData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEnergy = async () => {
      const Energy = await getEnergyData({ lang: "el" })
        .then((response) => {
          if (response.length > 0) {
            setLoading(false);
            return response;
          } else {
            setLoading(false);
            return [];
          }
        })
        .catch((error) => {
          setLoading(false);
          setError(error);
        });
      setEnergyData(Energy);
    };

    fetchEnergy();
  }, []);

  return (
    <EnergyDataContext.Provider
      value={{ energyData, setEnergyData, loading, error }}
    >
      {children}
    </EnergyDataContext.Provider>
  );
};

export default EnergyProvider;
